import { useList } from '../../../../api/react-query';

export function useLeaveTypeRules({ typeId, enabled = true }) {
  const { data, isLoading, isFetching, refetch } = useList(
    'engine/rule',
    { typeId, disablePageAndLimit: true },
    { enabled: !!typeId && enabled },
    'v1',
  );

  return {
    data: data?.data?.data || [],
    isLoading,
    isFetching,
    refetch,
  };
}
